"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBoxFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13 8h9v11.983c0 1.307-.667 1.973-2 1.998-1.333.025-6.667.025-16 0-1.333 0-2-.666-2-1.998V8h9v1c0 .668.334 1 1 1 .666 0 1-.332 1-1V8zm-2-2H2.385l1.49-3.001C4.14 2.333 4.514 2 5 2h14c.486 0 .855.333 1.107.999L21.617 6H13V2h-2v4zM6 16c-.667 0-1 .333-1 1 0 .665.333.998 1 .998h6c.667 0 1-.333 1-.999 0-.666-.333-.999-1-.999H6zm0-4c-.667 0-1 .333-1 1 0 .665.333.998 1 .998h3c.667 0 1-.333 1-.999 0-.666-.333-.999-1-.999H6z' }))); };
exports.default = SvgBoxFilled;
//# sourceMappingURL=BoxFilled.js.map